import axios from "../api";
const buildUrl = (data) => {
    let url = "user-players/";
    if (data.sort === "price") {
        url += "?sort-price";
    }
    else if (data.sort === "profit") {
        url += "?sort-profit";
    }
    else if (data.sort === "itemScore") {
        url += "?sort-item-score";
    }
    else {
        url += "?sort-rating";
    }
    if (data.ascending) {
        url += "=asc";
    }
    else {
        url += "=desc";
    }
    if (data.filters.size > 0) {
        url += "&filters=";
        data.filters.forEach((filter) => {
            url += filter + ",";
        });
        url = url.substring(0, url.length - 1);
    }
    url += "&page=" + data.page;
    url += "&limit=" + data.limit;
    return url;
};
export const getUserPlayers = async (data) => {
    const url = buildUrl(data);
    const res = await axios.get(url);
    return res.data;
};
export default getUserPlayers;
//# sourceMappingURL=getUserPlayers.js.map